import React, { Fragment } from 'react';

import type { FormInstance } from 'antd'

import type { AirdropRule } from '@api/index';
import { I18n } from '@utils/index';

import { InputBaseField } from '../InputBaseField';
import { TYPE_MAP } from '../SelectTypeField';
import { FORM_KYYS } from '../useMain';
import { formatFloatVal, validateRule } from '../utils';
import { Num } from './Num';
import { type ICache } from './useMaxAndMin'
export { type ICache } from './useMaxAndMin'

interface InputAmountFieldProps extends Partial<Omit<AirdropRule, 'releaseNumMax'>> {
  className?: string;
  name: string;
  cacheRef: React.MutableRefObject<ICache>;
}

const strategyMap: {
  [key: string]: {
    [key: string]: keyof Partial<Omit<AirdropRule, 'releaseNumMax'>>;
  }
} = {
  [TYPE_MAP.FORTUNE]: {
    min: 'releaseMin',
    max: 'releaseMax'
  },
  [TYPE_MAP.GENERAL]: {
    min: 'receiveMin',
    max: 'receiveMax'
  }
}

type IParams = {
  form: FormInstance,
  rest: Partial<Omit<AirdropRule, 'releaseNumMax'>>;
  key: 'min' | 'max';
  cacheRef: React.MutableRefObject<ICache>;
}

const renderNumber = ({ form, rest, key, cacheRef }: IParams) => {
  const currency = form.getFieldValue(FORM_KYYS.currency);
  const assignType = form.getFieldValue(FORM_KYYS.assignType);
  const precision = form.getFieldValue('precision');
  return <Num rules={rest} coinCode={currency} precision={precision} cacheRef={cacheRef} label={strategyMap[assignType][key]} />;
}

export const InputAmountField: React.FC<InputAmountFieldProps> = (props) => {
  const { name, className, cacheRef, ...rest } = props;
  return (
    <InputBaseField
      className={className}
      name={name}
      label={(form) => {
        const assignType = form.getFieldValue(FORM_KYYS.assignType)
        if (assignType === TYPE_MAP.FORTUNE) {
          return I18n.t('o4vWwYYy');
        }
        return I18n.t('MUxVeWP5');
      }}
      min={(form) => {
        return (
          <Fragment>
            ≈
            {renderNumber({ form, rest, key: 'min', cacheRef })}
          </Fragment>
        )
      }}
      max={(form) => {
        return (
          <Fragment>
            ≈
            {renderNumber({ form, rest, key: 'max', cacheRef })}
          </Fragment>
        )
      }}
      inputMode="decimal"
      shouldUpdate={(prevValues, curValues) => {
        return [FORM_KYYS.currency, name, FORM_KYYS.assignType, FORM_KYYS.num].some(item => prevValues[item] !== curValues[item])
      }}
      rules={[(form) => ({
        validator: (_, value) => {
          const realVal = Number(formatFloatVal(value));
          const assignType = form.getFieldValue(FORM_KYYS.assignType);
          const count = form.getFieldValue(FORM_KYYS.num);
          const currency = form.getFieldValue(FORM_KYYS.currency);
          return validateRule(
            { amount: realVal, cache: cacheRef, count, currency, assignType, form },
            { currKey: FORM_KYYS.amount, linkageKey: FORM_KYYS.num }
          );
        }
      })]}
    />
  );
}
